const InterestGroups = [
  {
    comingsoon: true,
    hassubgroups: true,
    id: "iotrf",
    interestgroup: "IoT Robotics and Digital Fabrications",
    interestgroupdescription:
      "Being smart yourself is not enough these days. You gotta have smart devices too. Smart enough to even drive manufacturing on their own! Need help? Join our Interest Group now to explore the world of automation at your own pace!",
    basicenablementtasks: [],
    learningpaths: [],
    corecourses: [],

    coretracks: [
      {
        id: "/iotrf/iot",
        description:
          "Our life, as well as the Internet, is full of amazing things. From the device on which you are reading this to the fan above your head, almost everything can be connected and controlled automatically. But How? Join our IoT Interest Group to learn how this can be achieved.",
        name: "Internet of Things",
        link: "/iotrf/iot",
        officetime: "Sunday 7:30 PM",
        officeplace: " @ Discord Lobby",
      },
    ],
    subcourses: [
      // {
      //   id: "",
      //   name: "",
      //   link: "",
      // },
    ],
    mentorscard: [
      {
        id: "",
        name: "",
        designation: "",
        linkedIn: "",
        stack: "",
        image: "",
      },
    ],
    pagination: [
      {
        id: "blockchain",
        name: "< Blockchain",
      },
      {
        id: "clouddevops",
        name: "Cloud & DevOps >",
      },
    ],
  },
  {
    comingsoon: true,
    hassubgroups: true,
    id: "webmobile",
    interestgroup: "Web and Mobile App Development",
    interestgroupdescription:
      "Creating the perfect place for your business or product to succeed is key nowadays. Learn how to create and develop eye catching web and mobile applications through our Interest Group. Join today! ",

    basicenablementtasks: [],
    learningpaths: [],
    corecourses: [],

    coretracks: [
      {
        id: "/webmobile/web",
        description:
          "Ever wondered how web applications are built? Everything seems Greek until you get to know how it is built. GTech μlearn's Web Development Interest Group aims to develop and fine-tune your Web Development skills and bring together people who wish to evaluate potential Web Technologies. Join now and Stay Updated!",
        name: "Web Development",
        link: "/webmobile/web",
        officetime: "Thursday 7:30 PM",
        officeplace: " @ Discord Lobby",
      },
      {
        id: "/webmobile/android",
        description:
          "Everything is at your fingertips, and you still don't know the working and stages of android development. Have you ever thought of exploring? Don't worry; Join our Android Development Interest Group right away and start feeding your curious minds from the basics.",
        name: "Android Development",
        link: "/webmobile/android",
        officetime: "Thursday 7:30PM",
        officeplace: " @ Discord Lobby",
      },
      {
        id: "/webmobile/qa",
        description:
          '"Join our Quality Assurance Interest Group to learn and collaborate with peers on best practices for measuring and improving product quality. Discover new testing strategies and Quality Assurance frameworks to ensure your products meet the highest standards of excellence."',
        name: "Quality Assurance",
        link: "/webmobile/qa",
        officetime: "Wednesday 7:00 PM",
        officeplace: " @ Discord Lobby",
      },
      {
        id: "/webmobile/flutter",
        description:
          "Flutter is an open-source mobile application development framework created by Google. It allows developers to build native applications for Android, iOS, and other platforms using a single codebase. Flutter uses the Dart programming language, which was also developed by Google, and provides a rich set of pre-built widgets and tools for building beautiful, fast, and responsive user interfaces.",
        name: "Flutter Development",
        link: "/webmobile/flutter",
        officetime: " Friday 9.00 PM",
        officeplace: " @ Discord Lobby",
      },
    ],
    subcourses: [
      // {
      //   id: "",
      //   name: "",
      //   link: "",
      // },
    ],
    mentorscard: [
      {
        id: "",
        name: "",
        designation: "",
        linkedIn: "",
        stack: "",
        image: "",
      },
    ],
    pagination: [
      {
        id: "blockchain",
        name: "< Blockchain",
      },
      {
        id: "clouddevops",
        name: "Cloud & DevOps >",
      },
    ],
  },
  {
    id: "cybersec",
    comingsoon: "true",
    interestgroup: "Cyber Security",
    interestgroupdescription:
      "Having an extra layer of security is always an advantage in the current world. The best way to prevent a cyber attack is to learn how it works and block all the loopholes that allow it. Want to learn? Join our Interest Group and learn from our expert mentors.",
    officetime: "Monday 7:30 PM",
    officeplace: " @ Discord Lobby",
    thinktankplace: " @ Google Meet",
    thinktanktime: "Sunday 9:00PM",
    community: ["Beagle Security"],
    opportunities: [
      "Malware Analyst",
      "Security Architect",
      "Computer Forensics Analyst",
      "Penetration Tester",
      "Cybersecurity Engineer",
    ],
    company: ["Beagle Security"],
    mentors: ["Rejah Rehim", "Anees", "Nash N Sulthan"],
    mentorscard: [
      {
        id: "S146",
        name: "Rejah Rehim",
        designation: "Director & Founder, Beagle Security",
        linkedIn: "https://www.linkedIn.com/in/rejah/",
        stack: "Cybersecurity",
        image:
          "https://drive.google.com/uc?export=view&id=1jLMLJQRC1wxfV1bNU_F8xWrybLEC-miM",
      },
      {
        id: "S148",
        name: "Nash N Sulthan",
        designation: "Senior Security Engineer",
        linkedIn: "https://www.linkedIn.com/in/nashns/",
        stack: "Cybersecurity",
        image:
          "https://drive.google.com/uc?export=view&id=1LY9k_PaAqooXRnEY2DtTYgtA7iZXfx2U",
      },
      {
        name: "Mufeed VH",
        stack: "Cybersecurity",
        image: "https://t3.ftcdn.net/jpg/01/18/01/98/360_F_118019822_6CKXP6rXmVhDOzbXZlLqEM2ya4HhYzSV.jpg"
      },
      {
        name: "Danwand",
        linkedIn: "https://www.linkedin.com/in/danwand/",
        stack: "Cybersecurity",
        image: "https://t3.ftcdn.net/jpg/01/18/01/98/360_F_118019822_6CKXP6rXmVhDOzbXZlLqEM2ya4HhYzSV.jpg"
      },
      {
        name: "Deepraj",
        linkedIn: "https://www.linkedin.com/in/deeprajr/",
        stack: "Cybersecurity",
        image: "https://t3.ftcdn.net/jpg/01/18/01/98/360_F_118019822_6CKXP6rXmVhDOzbXZlLqEM2ya4HhYzSV.jpg"
      },
      {
        name: "Vishnu Vijayan",
        linkedIn: "https://www.linkedin.com/in/vishnu-vijayan-vs/",
        stack: "Cybersecurity",
        image: "https://t3.ftcdn.net/jpg/01/18/01/98/360_F_118019822_6CKXP6rXmVhDOzbXZlLqEM2ya4HhYzSV.jpg"
      },
    ],
    pagination: [
      {
        id: "android",
        name: "< Android Development",
      },
      {
        id: "pm",
        name: "Product Management >",
      },
    ],
    learningpaths: [
      {
        id: "1",
        name: "Learning Path",
        link: "https://www.youtube.com/watch?v=yq561bLg10A&t=195s",
      },
      {
        id: "2",
        name: "Topics to Get Started",
        link: "https://www.youtube.com/watch?v=Kx4y9c7w2JQ",
      },
    ],
    basicenablementtasks: [],
    corecourses: [],
    subcourses: [],
    keywords: [
      {
        id: "1",
        keyword: "Metasploit",
      },
      {
        id: "2",
        keyword: "Wireshark",
      },
      {
        id: "3",
        keyword: "Ettercap",
      },
      {
        id: "4",
        keyword: "Snort",
      },
      {
        id: "5",
        keyword: "OpenVAS",
      },
      {
        id: "6",
        keyword: "Burp Suite",
      },
      {
        id: "7",
        keyword: "Kali Linux",
      },
      {
        id: "8",
        keyword: "VirtualBox",
      },
      {
        id: "9",
        keyword: "Docker",
      },
      {
        id: "9",
        keyword: "VMWare",
      },
    ],
    challenges: [
      {
        id: "1",
        name: "Real-Life Case Studies",
      },
      {
        id: "2",
        name: "Phishing Attacks",
      },
      {
        id: "3",
        name: "Software Vulnerabilities",
      },
      {
        id: "4",
        name: "Cryptography Attacks",
      },
      {
        id: "5",
        name: "IoT Attacks",
      },
      {
        id: "6",
        name: "System Hacking",
      },
    ],
    trendingprojectsprojects: [
      {
        name: "Anomaly detection, intrusion and its prevention",
      },
      {
        name: "Stalking threats and instance responding",
      },
      {
        name: "Detecting or mitigating compromising indicators",
      },
      {
        name: "Intelligence analyzing factors of ethical, privacy and  legal",
      },
      {
        name: "Research on relevant Geopolitical Cyber security",
      },
      {
        name: "Cyber security data analytics",
      },
      {
        name: "Data demonstration, fusion and semantic modeling",
      },
      {
        name: "Forecasting models on cyber-attacks and control measures",
      },
      {
        name: "Intelligence in cyber threat",
      },
      {
        name: "Models that concern Deception and Improbability in cyber-attack acknowledgement",
      },
      {
        name: "Visualizing intelligence analysis and investigation techniques",
      },
      {
        name: "Cybercrime monetization and orchestration and automating security",
      },
    ],
    specialization: [
      {
        id: "1",
        name: "Application security",
      },
      {
        id: "2",
        name: "Cryptography & key management",
      },
      {
        id: "3",
        name: "Cyber law & contracts",
      },
      {
        id: "4",
        name: "Forensics",
      },
      {
        id: "5",
        name: "Network security (firewalls etc.)",
      },
      {
        id: "6",
        name: "Penetration testing & red teaming",
      },
      {
        id: "7",
        name: "Policy management & governance",
      },
      {
        id: "8",
        name: "Risk assessment & governance",
      },
      {
        id: "9",
        name: "Security architecure",
      },
      {
        id: "10",
        name: "Security education & awareness",
      },
      {
        id: "11",
        name: "Security operations",
      },
      {
        id: "12",
        name: "Security systems engineering",
      },
    ],
    leads: [
      {
        id: "1",
        name: "Abhishek Santhosh",
        images: "/assets/interestGroups/abhishek.webp",
        college: "Carmel College of Engineering and Technology,Punnapra",
      },
      {
        id: "2",
        name: "Sooraj Mathew",
        images: "/assets/interestGroups/Sooraj.webp",
        college: "College of Engineering Trivandrum",
      },
    ],
  },
  {
    comingsoon: true,
    hassubgroups: true,
    id: "innovationentre",
    interestgroup: "Innovation and Entrepreneusrship",
    interestgroupdescription:
      "Think you're born to lead? Got a new idea that gives you an edge over your competitors? Join our Interest Group and let your innovations be reality and start off your journey of entrepreneurship today!",

    basicenablementtasks: [],
    learningpaths: [],
    corecourses: [],

    coretracks: [
      {
        id: "/innovationentre/pm",
        description:
          '"Product Management is deciding what to build next”. Are you interested in learning to build the right product and the product right? Join our “Product Management” Interest Group to learn and collaborate with peers.',
        name: "Product Management",
        link: "/innovationentre/pm",
        officetime: "Tuesday 8:30PM",
        officeplace: " @ Discord Lobby",
      },
      {
        id: "/innovationentre/innovent",
        description:
          "Join Innovation and Entrepreneurship today to experience the joy of building something unique, taking risks, and making good decisions. Drive innovation by introducing new ideas and utilizing cutting-edge technology to solve problems and meet customer needs.",
        name: "Innovation & Entrepreneurship",
        link: "/innovationentre/innovent",
        officetime: "Friday 10:00 PM",
        officeplace: " @ Discord Lobby",
      },
      {
        id: "/innovationentre/projectmanagment",
        description:
          "Effective project management involves setting goals, creating a plan, and coordinating resources to ensure successful project completion. Join our interest group to learn more about these techniques and best practices.",
        name: "Project Management",
        link: "/innovationentre/projectmanagment",
        officetime: "Thursday 6:30 PM",
        officeplace: " @ Discord Lobby",
      },
    ],
    subcourses: [
      // {
      //   id: "",
      //   name: "",
      //   link: "",
      // },
    ],
    mentorscard: [
      {
        id: "",
        name: "",
        designation: "",
        linkedIn: "",
        stack: "",
        image: "",
      },
    ],
    pagination: [
      {
        id: "blockchain",
        name: "< Blockchain",
      },
      {
        id: "clouddevops",
        name: "Cloud & DevOps >",
      },
    ],
  },
  {
    comingsoon: true,
    hassubgroups: true,
    id: "uiuxcreative",
    interestgroup: "UI UX Creative Design",
    interestgroupdescription:
      "Ever felt the look of an app could have been better? Ever felt the colours were off? If so, your 'interface' and 'experience' is what's being disturbed. Worry not, we're here to give you a full overview of UI/UX so you don't make the same mistakes when it's your turn to shine! Join now!",

    basicenablementtasks: [],
    learningpaths: [],
    corecourses: [],

    coretracks: [
      {
        id: "/uiuxcreative/ux",
        description:
          "Ever wondered how the vibrant apps and websites you see are designed? Wanna know how to? Join our interest group to learn with others with shared interests and get mentored by expert individuals.",
        name: "User Experience (UX)",
        link: "/uiuxcreative/ux",
        officetime: "Saturday 8:00 PM",
        officeplace: " @ Discord Lobby",
      }
    ],
    subcourses: [
      // {
      //   id: "",
      //   name: "",
      //   link: "",
      // },
    ],
    mentorscard: [
      {
        id: "",
        name: "",
        designation: "",
        linkedIn: "",
        stack: "",
        image: "",
      },
    ],
    pagination: [
      {
        id: "blockchain",
        name: "< Blockchain",
      },
      {
        id: "clouddevops",
        name: "Cloud & DevOps >",
      },
    ],
  },
  {
    comingsoon: true,
    hassubgroups: true,
    id: "arvrxr",
    interestgroup: "AR VR XR and 3D Animation & Game Development",
    interestgroupdescription:
      "Wanna access the reality you wish to explore in the form of AR, VR and XR? Learn how to access this reality of yours through our Interest Group focused on augmented, virtual and extended realities. Join now!",

    basicenablementtasks: [],
    learningpaths: [],
    corecourses: [],

    coretracks: [
      {
        id: "/arvrxr/arvr",
        description:
          "Augmented Reality and Virtual Reality bridge the gap between the real and digital world and help you conceive digital information in the same way you do in the real world. Join the Interest Group today to delve deeper into the Digital World!",
        name: "Aguemented Reality",
        link: "/arvrxr/arvr",
        officetime: "Sunday 08:30 PM",
        officeplace: " @ Discord Lobby",
      },
    ],
    subcourses: [
      // {
      //   id: "",
      //   name: "",
      //   link: "",
      // },
    ],
    mentorscard: [
      {
        id: "",
        name: "Udesh Udaykumar",
        designation: "",
        linkedIn: "https://www.linkedin.com/in/udesh-udayakumar/",
        stack: "Cloud Computing",
        image: "",
      },
    ],
    pagination: [
      {
        id: "blockchain",
        name: "< Blockchain",
      },
      {
        id: "clouddevops",
        name: "Cloud & DevOps >",
      },
    ],
  },
  {
    comingsoon: true,
    hassubgroups: true,
    id: "aimlanalytics",
    interestgroup: "AI ML and Analytics",
    interestgroupdescription:
      "We live in an age where computers have started predicting the outputs based on its experience with handling data. Join the AI, ML and Analytics Interest Group to learn how to train, test and validate your system to do the same as well as analyse datasets of your requirements. See you on board!",

    basicenablementtasks: [],
    learningpaths: [],
    corecourses: [],

    coretracks: [
      {
        id: "/aimlanalytics/ai",
        description:
          "AI is the simulation of Human Intelligence processes by computer systems Worried if AI will take over the World in the near future? Join our AI Interest Group and learn more about Artificial Intelligence and the latest advancements in the domain.",
        name: "Artificial Intellgence",
        link: "/aimlanalytics/ai",
        officetime: "Thursday 9:00 PM",
        officeplace: " @ Discord Lobby",
      },
    ],
    subcourses: [
      // {
      //   id: "",
      //   name: "",
      //   link: "",
      // },
    ],
    mentorscard: [
      {
        id: "",
        name: "",
        designation: "",
        linkedIn: "",
        stack: "",
        image: "",
      },
    ],
    pagination: [
      {
        id: "blockchain",
        name: "< Blockchain",
      },
      {
        id: "clouddevops",
        name: "Cloud & DevOps >",
      },
    ],
  },
  {
    id: "blockchain",
    interestgroup: "Blockchain",
    interestgroupdescription:
      "Block chain is a new age technology that makes transactions much more secure and decentralized. The rapid advancements in Blockchain have led to the development of Web 3.0 and has given rise to several crypto-currencies. Join the Blockchain Interest Group to get a better grasp over this world-changing technology.",
    officetime: " Monday 8.30 PM",
    officeplace: " @ Discord Lobby",
    thinktankplace: " @ Google Meet",
    thinktanktime: " Sunday 8:30 PM",
    community: ["KBA"],
    opportunities: [],
    company: [],
    pagination: [
      {
        id: "ai",
        name: "< Artificial Intelligence",
      },
      {
        id: "civil",
        name: "Civil Engineering >",
      },
    ],
    learningpaths: [
      {
        id: "1",
        name: "Blockchain - Coding Ninjas",
        link: "https://www.codingninjas.com/codestudio/guided-paths/blockchain",
      },
    ],
    basicenablementtasks: [
      {
        name: "10 days of Solidity",
        link: "/blockchain/enablement/1",
        complexity: "",
        time: "",
        karma: "100",
      },
      {
        name: "How to create your own blockchain",
        link: "/blockchain/enablement/2",
        complexity: "",
        time: "",
        karma: "100",
      },
      {
        name: "Writing your first Hello World contract in Solidity",
        link: "/blockchain/enablement/3",
        complexity: "",
        time: "",
        karma: "100",
      },
      {
        name: "Build your own web3 Twitter dApp with Solidity",
        link: "/blockchain/enablement/4",
        complexity: "",
        time: "",
        karma: "100",
      },
      {
        name: "Create your own Solana token in just 10 mins",
        link: "/blockchain/enablement/5",
        complexity: "",
        time: "",
        karma: "100",
      },
      {
        name: "How to create your own token on Binance",
        link: "/blockchain/enablement/6",
        complexity: "",
        time: "",
        karma: "100",
      },
      {
        name: "Understand and setup MetaMask Account",
        link: "/blockchain/enablement/7",
        complexity: "",
        time: "",
        karma: "100",
      },
      {
        name: "Add MetaMask connect button to your react app",
        link: "/blockchain/enablement/8",
        complexity: "",
        time: "",
        karma: "100",
      },
      {
        name: "Learn everything about NFTs",
        link: "/blockchain/enablement/9",
        complexity: "",
        time: "",
        karma: "100",
      },
      {
        name: "Creating NFTs using different token standards",
        link: "/blockchain/enablement/10",
        complexity: "",
        time: "",
        karma: "100",
      },
      {
        name: "Launch your own epic NFT marketplace",
        link: "/blockchain/enablement/11",
        complexity: "",
        time: "",
        karma: "100",
      },
      {
        name: "Create a Horoscope Web3 NFT Application",
        link: "/blockchain/enablement/12",
        complexity: "",
        time: "",
        karma: "100",
      },
      {
        name: "How to write a smart contract and mint Elon Musk NFT on OpenSea",
        link: "/blockchain/enablement/13",
        complexity: "",
        time: "",
        karma: "100",
      },
      {
        name: "Introduction to Polygon and its Architecture",
        link: "/blockchain/enablement/14",
        complexity: "",
        time: "",
        karma: "100",
      },
      {
        name: "Launch your own token on Polygon Network in 30 mins",
        link: "/blockchain/enablement/15",
        time: "",
        karma: "100",
      },
      {
        name: "How does Ethereum work? A deepdive",
        link: "/blockchain/enablement/16",
        complexity: "",
        time: "",
        karma: "100",
      },
      {
        name: "Create your own Ethereum token in just 30 mins",
        link: "/blockchain/enablement/17",
        complexity: "",
        time: "",
        karma: "100",
      },
    ],
    corecourses: [],
    subcourses: [],
    leads: [
      {
        id: 1,
        name: "Akshay S Rajan",
        college: "IHRD College Of Applied Science, Perissery",
        images: "/assets/interestGroups/akshay.webp",
        linkedIn: "https://www.linkedin.com/in/akshaysrajan/",
      },
    ],
    mentors: ["1"],
    mentorscard: [
      {
        id: "1",
        name: "Nikhil V Chandran",
        stack: "Kerala Blockchain Academy",
        linkedIn: "https://in.linkedin.com/in/nikhil-v-chandran-69260120",
        image:
          "https://t3.ftcdn.net/jpg/01/18/01/98/360_F_118019822_6CKXP6rXmVhDOzbXZlLqEM2ya4HhYzSV.jpg",
      },
      {
        name: "Jikku Jose",
        linkedIn: "https://www.linkedin.com/in/jikkujose/",
        image:
          "https://t3.ftcdn.net/jpg/01/18/01/98/360_F_118019822_6CKXP6rXmVhDOzbXZlLqEM2ya4HhYzSV.jpg",
      },
      {
        name: "Gyanlakshmi",
        linkedIn: "",
        stack: "Blockchain",
        image:
          "https://t3.ftcdn.net/jpg/01/18/01/98/360_F_118019822_6CKXP6rXmVhDOzbXZlLqEM2ya4HhYzSV.jpg",
      },
      {
        name: "Shubhanga R Beeragere ",
        linkedIn:
          "https://www.linkedin.com/in/shubhanga-r-beeragere-918b8b18a/",
          image:
          "https://t3.ftcdn.net/jpg/01/18/01/98/360_F_118019822_6CKXP6rXmVhDOzbXZlLqEM2ya4HhYzSV.jpg",
      },
    ],
  },
  {
    comingsoon: true,
    hassubgroups: true,
    id: "noncircuit",
    interestgroup: "Non Circuit Branches",
    interestgroupdescription:
      "Ever felt the non circuit branches of engineering are not receiving the attention they deserve? Fear not, because we are here to give you what you deserve! An opportunity to explore beyond computers and electronics to the ways of mechanics and infrastructure. Join our Interest Group for all things related to non circuit branches!",

    basicenablementtasks: [],
    learningpaths: [],
    corecourses: [],

    coretracks: [
      {
        id: "/noncircuit/civil",
        description:
          "Get ahead in your Civil Engineering career by joining GTech μlearn's Civil Interest Group. Learn AutoCAD, BIM, and Revit from industry experts. Gain hands-on experience and practical skills. Join us now to take the next step in your career.",
        name: "Civil Engineering",
        link: "/noncircuit/civil",
        officetime: "Wednesday 7:00 PM",
        officeplace: " @ Discord Lobby",
      },
    ],
    subcourses: [
      // {
      //   id: "",
      //   name: "",
      //   link: "",
      // },
    ],
    mentorscard: [
      {
        id: "",
        name: "",
        designation: "",
        linkedIn: "",
        stack: "",
        image: "",
      },
    ],
    pagination: [
      {
        id: "blockchain",
        name: "< Blockchain",
      },
      {
        id: "clouddevops",
        name: "Cloud & DevOps >",
      },
    ],
  },
  {
    id: "clouddevops",
    interestgroup: "Cloud & DevOps",
    interestgroupdescription:
      "The emergence of Cloud technologies have changed the world forever.If you’re keen to know how the Cloud works and what DevOps is, here’s your chance to do so. Join the Cloud & DevOps Interest Group today and learn more.",
    basicenablementtasks: [],
    learningpaths: [
      {
        id: "1",
        name: "DevOps Roadmap",
        link: "https://roadmap.sh/devops",
      },
      {
        id: "2",
        name: "DevOps Engineer Roadmap - YouTube",
        link: "https://www.youtube.com/watch?v=9pZ2xmsSDdo",
      },
    ],
    corecourses: [],
    subcourses: [],
    mentors: ["Vivek"],
    mentorscard: [
      {
        id: "1",
        name: "Vivek R",
        stack: "Distributed Systems, Networks, Security",
        linkedIn: "https://www.linkedin.com/in/123vivekr/",
        image: "/assets/mentors/Vivek-R.webp",
      },
    ],
    officetime: "Monday 7:30 PM",
    comingsoon: true,
    thinktankplace: " @ Google Meet",
    thinktanktime: " Sunday 9:30PM",
    officeplace: " @ Discord Lobby",
    community: [],
    opportunities: [],
    company: [],
    pagination: [
      {
        id: "blockchain",
        name: "< Blockchain",
      },
      {
        id: "innovation",
        name: "Innovation >",
      },
    ],
  },
  // {
  //   id: "digitalmarketing",
  //   interestgroup: "Digital Marketing",
  //   interestgroupdescription:
  //     "Think you have the skill to market any product? Join the Marketing Interest Group to learn latest marketing strategies, interact with Marketing experts and develop some much needed experience in the field.",
  //   officetime: "Saturday and Sunday 8:00pm",
  //   comingsoon: true,
  //   officeplace: " @ Discord Lobby",
  //   // thinktankplace: " @ Google Meet",
  //   // thinktanktime: "Monday 6:00 PM",
  //   community: [],
  //   opportunities: [],
  //   company: [],
  //   mentors: [],
  //   mentorscard: [],
  //   pagination: [
  //     {
  //       id: "creativedesign",
  //       name: "< Creative Design",
  //     },
  //     {
  //       id: "entrepreneurship",
  //       name: "Entrepreneurship >",
  //     },
  //   ],
  //   learningpaths: [],
  //   basicenablementtasks: [],
  //   corecourses: [],
  //   subcourses: [],
  //   "": {},
  // },
];

export default InterestGroups;
